import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import {
  isDeliveredFromModel,
  validateIsDeliveredCondition,
  type IsDeliveredState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const IS_DELIVERED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsDeliveredState>>,
): ConditionType<IsDeliveredState, Condition.IsDelivered> => ({
  get name() {
    return t("Package delivered");
  },
  description(state) {
    return t("The carrier reports the item's package as delivered");
  },
  Details(props: ConditionTypeDetailsProps<IsDeliveredState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return isDeliveredFromModel(model);
  },
  toModel(state) {
    return { type: Condition.IS_DELIVERED };
  },
  valid(state) {
    return validateIsDeliveredCondition(state).valid;
  },
});
